/**
 * useStreamRecording — recording blob state and max minutes limit
 * Phase 4 (PRI-291): extracted from useStreamSession
 *
 * Owns: recordingBlob, recordingMaxMinutes
 * The MediaRecorder lifecycle itself lives in the orchestrator (useStreamSession)
 * since it's interleaved with the WS/WebRTC lifecycle.
 */

import { useState } from 'react'

export interface StreamRecordingReturn {
  recordingBlob: Blob | null
  setRecordingBlob: React.Dispatch<React.SetStateAction<Blob | null>>
  recordingMaxMinutes: number
  setRecordingMaxMinutes: React.Dispatch<React.SetStateAction<number>>
  resetRecording: () => void
}

export function useStreamRecording(): StreamRecordingReturn {
  const [recordingBlob, setRecordingBlob] = useState<Blob | null>(null)
  const [recordingMaxMinutes, setRecordingMaxMinutes] = useState<number>(30)

  const resetRecording = () => {
    setRecordingBlob(null)
    // Keep recordingMaxMinutes - it's a user preference, not session state
  }

  return {
    recordingBlob,
    setRecordingBlob,
    recordingMaxMinutes,
    setRecordingMaxMinutes,
    resetRecording,
  }
}
